<div class="fleet-selector">
  <div class="form-group">
    <p></p>
    <label for="fleetSelect" class="form-label">Fleet Health:</label><br/>
    <div *ngIf="loading" class="spinner-border spinner-border-sm ms-2" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
    <div *ngIf="error" class="alert alert-danger mt-2">{{ error }}</div>
    <div *ngIf="!loading" class="health-summary">
      <div class="indicator no-alerts" (click)="setIndicatorCLicked('withNoAlerts')">{{ alertsSummary?.withNoAlerts ?? 0 }}</div>
      <div class="indicator warnings" (click)="setIndicatorCLicked('withWarnings')">{{ alertsSummary?.withWarnings ?? 0 }}</div>
      <div class="indicator errors" (click)="setIndicatorCLicked('withErrors')">{{ alertsSummary?.withErrors ?? 0 }}</div>
      <div><button type="button" class="btn btn-danger" (click)="setIndicatorCLicked('withQCErrors')">QC: {{ alertsSummary?.withQCErrors ?? 0 }}</button></div>
      <div><button type="button" class="btn btn-warning" (click)="setIndicatorCLicked('withQCAlerts')">QC: {{ alertsSummary?.withQCAlerts ?? 0 }}</button></div>
    </div>
  </div>
</div>
